import { combineReducers } from 'redux';
import { routerReducer } from 'react-router-redux';
import { reducer as formReducer } from 'redux-form';
import WorkersReducer from '../../worker/reducers/WorkerReducer';
import WorksReducer from '../../works/reducers/WorksReducer';
import WorkerFormReducer from '../../worker/reducers/WorkerFormReducer';
import MachinesReducer from '../../machines/reducers/MachineReducer';
import MachineFormReducer from '../../machines/reducers/MachineFormReducer';
import SchemaTypeReducer from '../../documents/reducers/SchemaTypeReducer';
import AuthReducer from '../../login/reducer/AuthReducer';
import WorksRecentlyAddedReducer from '../../works/reducers/WorksRecentlyAddedReducer';
import CompanyReducer from '../../company/reducers/CompanyReducer';
import UserReducer from '../../users/reducers/UserReducer';
import ProfileReducer from '../../profile/reducers/ProfileReducer';
import DocumentStatesReducer from '../../documents/reducers/DocumentStatesReducer';
import OutsourcesReducer from '../../outsource/reducers/OutsourcesReducer';
import TypeDocumentsReducer from '../../documents/reducers/TypeDocumentsReducer';
import DocumentsReducer from '../../documents/reducers/DocumentsReducer';
import MessagesReducer from '../../messages-notifications/messages/to-refactor/shared/reducer/MessagesReducer';
import ProfileFormReducer from '../../profile/reducers/ProfileFormReducer';
import DocumentFormReducer from '../../documents/reducers/DocumentFormReducer';
import DocumentRevisionsReducer from '../../documents/reducers/DocumentRevisionsReducer';
import WorksImportReducer from '../../works/reducers/WorksImportReducer';
import SchemeDocumentsReducer from '../../documents/reducers/SchemeDocumentsReducer';
import CompanyAutocompleteReducer from '../../company/reducers/CompanyAutocompleteReducer';
import ConstructionsAutocompleteReducer from '../../works/reducers/ConstructionsAutocompleteReducer';
import MonthlyReducer from '../../my-outsources/monthly/reducer/MonthlyReducer';
import TasksReducer from '../../my-outsources/tasks/list/reducers/TasksReducer';
import ImportOutsourcesReducer from '../../outsource/reducers/ImportOutsourcesReducer';
import MessageDetailReducer from '../../messages-notifications/messages/to-refactor/shared/reducer/MessageDetailReducer';
import ExportOutsourceDocsReducer from '../../outsource/reducers/ExportOutsourceDocsReducer';
import RemoveReducer from '../../remove/reducers/RemoveReducer';
import PaperBinReducer from '../../paperbin/reducer/PaperBinReducer';
import UserAutocompleteReducer from '../../users/reducers/UserAutocompleteReducer';
import UserAdminCopyCompaniesReducer from '../../users/reducers/UserAdminCopyCompaniesReducer';
import ContractorsReducer from '../../contractors/reducers/ContractorsReducer';
import AttachmentReducer from '../../attachment/AttachmentReducer';

const rootReducer = combineReducers({
    form: formReducer,
    routing: routerReducer,
    workers: WorkersReducer,
    formWorker: WorkerFormReducer,
    schemaType: SchemaTypeReducer,
    documentRevisions: DocumentRevisionsReducer,
    documentStates: DocumentStatesReducer,
    documents: DocumentsReducer,
    formDocument: DocumentFormReducer,
    works: WorksReducer,
    worksImport: WorksImportReducer,
    worksRecentlyAdded: WorksRecentlyAddedReducer,
    constructionAutocomplete: ConstructionsAutocompleteReducer,
    auth: AuthReducer,
    machines: MachinesReducer,
    formMachine: MachineFormReducer,
    companies: CompanyReducer,
    companiesAutocomplete: CompanyAutocompleteReducer,
    usersAutocomplete: UserAutocompleteReducer,
    users: UserReducer,
    profile: ProfileReducer,
    formProfile: ProfileFormReducer,
    outsources: OutsourcesReducer,
    importOutsources: ImportOutsourcesReducer,
    exportOutsourceDocs: ExportOutsourceDocsReducer,
    remove: RemoveReducer,
    typedocuments: TypeDocumentsReducer,
    schemeDocuments: SchemeDocumentsReducer,
    messages: MessagesReducer,
    messageDetail: MessageDetailReducer,
    monthly: MonthlyReducer,
    tasks: TasksReducer,
    paperBin: PaperBinReducer,
    userAdminCopyCompanies: UserAdminCopyCompaniesReducer,
    contractors: ContractorsReducer,
    attachment: AttachmentReducer,
});

export default rootReducer;



// WEBPACK FOOTER //
// ./src/app/shared/reducers/index.js